import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Container, VLine } from "../styles";
import { Container as CardContainer } from "../CardHistorico/styles";

interface SkeletonItemHistoricoProps {
    lastItem?: boolean;
}

export default function SkeletonItemHistorico({ lastItem = false }: SkeletonItemHistoricoProps) {
    return (
        <Container>
            <VLine lastItem={lastItem} />
            <div className="items">
                <div className="data">
                    <Skeleton height={12} width={70} className="data-texto" style={{ marginBottom: '2px', lineHeight: '1.2' }} />
                    <Skeleton height={14} width={65} className="hora-texto" style={{ lineHeight: '1.2', fontWeight: 600 }} />
                </div>
                <div className="icone">
                    <Skeleton circle height={30} width={30} />
                </div>
                <CardContainer>
                    <div className="top">
                        <div className="acao">
                            <Skeleton height={16} width={200} style={{ lineHeight: '1.5' }} />
                        </div>
                        <div className="infos">
                            <Skeleton circle height={16} width={16} />
                            <Skeleton height={10} width={10} circle />
                            <Skeleton height={12} width={50} className="codigo" style={{ lineHeight: '1.2' }} />
                            <Skeleton height={16} width={16} />
                        </div>
                    </div>
                    <div className="bottom">
                        <Skeleton circle height={14} width={14} />
                        <Skeleton height={12} width={120} style={{ lineHeight: '1.2' }} />
                        <Skeleton height={20} width={80} borderRadius={11} style={{ padding: '3px 8px' }} />
                    </div>
                </CardContainer>
            </div>
        </Container>
    );
}

